













































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import { Customer } from '@/models/customer';
import HttpClient from '@/utility/http-client';

@Component
export default class ProfileRight extends Vue {
    @Prop({ default: null })
    private customer!: Customer;

    @Prop({ default: null })
    private submitForm!: any;

    @Watch('submitForm', { immediate: true, deep: true })
    private async watchSubmitForm() {
        if (this.submitForm) {
            if (await this.validateForm() === true) {
                await this.submitForm();
            }
        }
    }

    private tab = {
        customerInfo: 'customerInfo',
        password: 'password'
    };
    private selectedTab = this.tab.customerInfo;

    private onSelectedTab(tab: any) {
        this.selectedTab = tab;
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    private async validateForm() {
        const valid = this.$refs['observer'] as any;

        if (!valid) { return false; }
        if (await valid.validate() === true) { return true; }

        if (valid.refs['RePassword'] && valid.refs['RePassword'].flags.valid === false || valid.refs['Password'] && valid.refs['Password'].flags.valid === false) {
            this.selectedTab = this.tab.password;
            return false;
        }

        this.selectedTab = this.tab.customerInfo;
        return false;
    }

    private uploading = {
        CccdFront: false,
        CccdBack: false,
        DkkdLicense: false
    };

    private openUploader(refName: string) {
        const el = this.$refs[refName] as HTMLInputElement;
        if (el) {
            el.click();
        }
    }

    private isImage(url: string) {
        if (!url) { return false; }
        return url.match(/\.(jpeg|jpg|gif|png)$/i);
    }

    private async uploadFile(e: any, fieldName: string) {
        const file = e.target.files[0];
        if (!file) { return; }
        (this.uploading as any)[fieldName] = true;
        
        const formData = new FormData();
        formData.append('imagefile', file);
        formData.append('filename', file.name);
        
        try {
            const res = await HttpClient.instance().post('/api/complain/uploadfile/', formData);
            if (res && res.status === 200 && res.data) {
                this.$set(this.customer, fieldName, res.data.data);
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Lỗi!',
                    text: 'Tải file thất bại.'
                });
            }
        } catch (err) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Lỗi!',
                text: 'Lỗi kết nối khi tải file.'
            });
        } finally {
            (this.uploading as any)[fieldName] = false;
            e.target.value = '';
        }
    }

    private removeFile(fieldName: string) {
        this.$set(this.customer, fieldName, null);
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
    }
}
